<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        <strong>You Will Need:</strong> Word processing software (such as Google Docs or Microsoft
        Word), or a piece of paper, a pen and either a scanner or a camera to upload your work
      </p>
      <centered-image-wrapper
        :image="image1"
        classes="2/3"
        alt="SWOT analysis grid. Columns: Helpful to achieving the objective, and Harmful to achieving the objective. Rows: Internal origin (attributes of the organisation), and External origin (attributes of the environment). Internal and helpful: Strengths. Internal and harmful: Weaknesses. External and helpful: Opportunities. External and harmful: Threats."
      />
      <p class="mb-5">
        Before you start this exercise, it might be helpful to have a refresher of how a SWOT chart
        works in the Learning Resources page.
      </p>
      <p class="mb-5">
        In this scenario, your business is already under way, and you want to figure out what your
        strategy is going to be for the upcoming business year.
      </p>
      <p class="mb-5">
        Your task is to go through and come up with 3-5 points that belong in each area of the chart
        - the strengths, weaknesses, opportunities and threats.
      </p>
      <p class="mb-5">
        Once those have been completed, write 3-5 things your business could do that will either:
      </p>

      <ul class="mb-5">
        <li>Build your strengths,</li>
        <li>Minimize your weaknesses,</li>
        <li>Take advantage of opportunities, or</li>
        <li>Avoid or address threats to your business</li>
      </ul>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="doc"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      image1: require('@/assets/images/experiences/entrepreneur/lr1.png'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
